import { Box, TextField } from "@mui/material";
import ThemeSelector from "./ThemeSelector";
import DisplaySelector from "./DisplaySelector";
import ButtonBar from "./ButtonBar";

export default function MenuBar(props) {
  return (
    <>
      <Box
        style={{
          width: "100%",
          marginBottom: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "#f5f5f5",
          gap: 5,
          padding: 10,
          mr: 3,
        }}
      >
        <TextField
          id="outlined-fixed"
          label="Diagram Title"
          placeholder="Title for diagram"
          value={props.title}
          onChange={(event) => props.updateTitle(event.target.value)}
        />
        <ThemeSelector
          handleThemeChange={props.handleThemeChange}
          selectedTheme={props.theme}
        />
        <DisplaySelector
          selectedOrientation={props.selectedOrientation}
          selectedSliderValue={props.selectedSliderValue}
          handleOrientationChange={props.handleOrientationChange}
          handleSliderValueChange={props.handleSliderValueChange}
        />
        <Box sx={{ flexGrow: 1 }} />
        <ButtonBar
          data={props.data}
          updateButtonClicked={props.updateButtonClicked}
          shareDiagram={props.shareDiagram}
          saveData={props.saveData}
          database={props.database}
          projectId={props.projectId}
          try_callback={props.try_callback}
        />
      </Box>
    </>
  );
}
